<template>
 <nav class="flex flex-wrap items-center justify-between p-5 bg-white" id = "dashboard-navbar" >      
 <img
    class="h-16 w-auto"
    src="../assets/images/Springmatter-Icon.png"
    alt="Springmatter"
  />
   <div class="-ml-2 mr-2 flex items-center lg:hidden">
            <!-- Mobile menu button -->
            <button
              class="inline-flex items-center justify-center p-2 rounded-md
               text-gray-400 hover:text-white hover:bg-gray-700
              focus:outline-none focus:bg-gray-700 focus:text-white transition
              duration-150 ease-in-out"
              aria-label="Main menu"
              aria-expanded="false"
              v-on:click="toggle"
            >
              <!-- Icon when menu is closed. -->
              <!--
              Heroicon name: menu
              Menu open: "hidden", Menu closed: "block"
            -->
              <svg
                class="toggle block h-6 w-6"
                :class="{'hidden': toggled}"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
              <!-- Icon when menu is open. -->
              <!--
              Heroicon name: x

              Menu open: "block", Menu closed: "hidden"
            -->
              <svg
                class="toggle h-6 w-6"
                :class="{'hidden': !toggled}"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
        </div>
  <div class="toggle lg:flex w-full lg:w-auto text-center text-bold mt-5 lg:mt-0 border-t-2 border-gray-500 lg:bg-none bg-white lg:border-none"
      :class="{'hidden': !toggled}"
      id = "links">        
     <router-link
                :to="{ name: 'Narratives', params: { username: username } }"
                class="px-3 py-2 text-sm font-medium leading-5
                text-white focus:outline-none
                transition duration-150 ease-in-out
                block lg:inline-block lg:border-none border-b-2 border-gray-500"
                style = "font-size: 18px"
                >NARRATIVES</router-link>

                <a href = "http://www.springmatter.org"
                class="px-3 py-2  text-sm font-medium leading-5
                text-white focus:outline-none
                transition duration-150 ease-in-out
                block lg:inline-block lg:border-none border-b-2 border-gray-500"
                style = "font-size: 18px"
                >SPRINGMATTER FUND</a>
              
              <a
              href = "#contact-us"
              class="px-3 py-2 text-sm font-medium leading-5
              text-white focus:outline-none
              transition duration-150 ease-in-out
              block lg:inline-block lg:border-none border-b-2 border-gray-500"
              style = "font-size: 18px"
              >CONTACT US</a>

              <router-link
              v-if = "isSignedIn"
              :to="{ name: 'Narratives', params: { username: username } }"
              class="lg:hidden px-3 py-2 text-sm font-medium leading-5
              text-white focus:outline-none
              transition duration-150 ease-in-out
              block lg:inline-block lg:border-none border-b-2 border-gray-500"
              style = "font-size: 18px"
              >YOUR PROFILE</router-link>

              <router-link
              v-if = "isSignedIn"
              :to="{ name: 'Narratives', params: { username: username } }"
              class="lg:hidden px-3 py-2 text-sm font-medium leading-5
              text-white focus:outline-none
              transition duration-150 ease-in-out
              block lg:inline-block lg:border-none border-b-2 border-gray-500"
              style = "font-size: 18px"
              >SETTINGS</router-link>

              <a
              v-if = "isSignedIn"
              @click = "signOut"
              class="lg:hidden px-3 py-2 text-sm font-medium leading-5
              text-white focus:outline-none
              transition duration-150 ease-in-out
              block lg:inline-block lg:border-none border-b-2 border-gray-500"
              style = "font-size: 18px"
              >SIGN OUT</a>

            <a
              v-if = "!isSignedIn"
              @click="login('login')"
              class="lg:hidden px-3 py-2 text-sm font-medium leading-5
              text-white focus:outline-none
              transition duration-150 ease-in-out
              block lg:inline-block lg:border-none border-b-2 border-gray-500"
              style = "font-size: 18px"
              >LOG IN</a>
      </div>
      <div class="hidden lg:flex lg:w-auto lg:ml-3 lg:flex-shrink-0 lg:flex items-right" v-if = "isSignedIn"  v-click-outside="closeMenu">
       <div class="ml-3 relative">
              <div>
                <button
                  class="flex text-sm border-2 border-transparent rounded-full
                  focus:outline-none focus:border-gray-300 transition
                  duration-150 ease-in-out"
                  id="user-menu"
                  aria-label="User menu"
                  aria-haspopup="true"
                  v-on:click="openMenu"
                >
                  <span
                    class="inline-block h-10 w-10 rounded-full overflow-hidden bg-gray-100"
                  >
                    <svg
                      class="h-full w-full text-gray-300"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004
                        15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0
                        11-8 0 4 4 0 018 0z"
                      />
                    </svg>
                  </span>
                </button>
              </div>
           
               <div
                class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg"
              >
                <div
                  class="py-1 rounded-md bg-white shadow-xs"
                  role="menu"
                  aria-orientation="vertical"
                  aria-labelledby="user-menu"
                  v-if="menuOpened"
                >
                  <a
                    href="#"
                    class="block px-4 py-2 text-sm leading-5 text-gray-700
                    hover:bg-gray-100 focus:outline-none focus:bg-gray-100
                    transition duration-150 ease-in-out"
                    role="menuitem"
                    >Your Profile</a
                  >
                  <a
                    class="block px-4 py-2 text-sm leading-5 text-gray-700
                    hover:bg-gray-100 focus:outline-none focus:bg-gray-100
                    transition duration-150 ease-in-out"
                    role="menuitem"
                    >Settings</a
                  >
                  <a
                    @click="signOut"
                    class="block px-4 py-2 text-sm leading-5 text-gray-700
                    hover:bg-gray-100 focus:outline-none focus:bg-gray-100
                    transition duration-150 ease-in-out cursor-pointer"
                    role="menuitem"
                    >Sign out</a
                  >
                </div>
              </div>
            </div>
            </div>
    <div class="hidden lg:flex lg:w-auto lg:ml-3 lg:flex-shrink-0 lg:flex items-right"  v-if = "!isSignedIn" id = "login">
          <a
                @click="login('login')"
                class=""
                style = "font-size: 18px; color: #47aa42"
                >LOG IN</a
              >
          <button style = "position:relative; right:30px;"
            class="inline-flex items-center justify-center p-2 rounded-lg
            focus:outline-none"
            aria-label="login"
            @click="login('login')"

          >
            <svg
              class="h-6 w-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="#47aa42 "
              viewBox="0 0 24 24"
              stroke="#47aa42 "
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M14 5l7 7m0 0l-7 7m7-7H3"
              />
            </svg>
          </button>
      </div>
</nav>  
</template>

<script>

import vClickOutside from 'v-click-outside'



export default {
  components: {},

  props: [],

  data() {
    return {
      menuOpened: false,
      toggled: false,
    };
  },

  watch: {},

   directives: {
    clickOutside: vClickOutside.directive
  },

  methods: {
    openMenu(event) {
      this.menuOpened = !this.menuOpened;
      event.stopPropagation();
    },
    closeMenu() {
      this.menuOpened = false;
    },
    login(prompt) {
      this.$auth.loginWithRedirect({ prompt });
    },

    signOut() {
      this.$auth.logout({
        returnTo: window.location.origin
      });
      this.$store.dispatch("users/signOut");
      this.$router.push("/");
    },

    toggle() {
      this.toggled = !this.toggled
    },
  },
  

  computed: {
    username() {
      return this.$store.state.users.user.username;
    },
    dashboard() {
      var location = {
        name: "Dashboard",
        params: { username: this.$store.state.users.user.username },
      };
      return location;
    },
    isSignedIn() {
     return this.$store.state.users.user.username != undefined;
    }
  },

  mounted() {},
};
</script>

<style>
#links {
  z-index:1000; 
  background: "white"; 
}
.link {
}

#dashboard-navbar {
  height: 100px;
  z-index: 10000;
}

#dashboard-navbar a{
  color: #282828;
  font-weight: bold;
  padding: 30px;
  text-align: center;
}

#dashboard-navbar a:hover {
    color: gray;

}
a:hover {
 cursor:pointer;
}

</style>